import React from 'react';
import { func } from 'prop-types';

import LabelActions from './LabelActions';

const TargetLabelMainHeader = ({ exportTarget }) => {
  return (
    <div className="de--header" data-test="target-main-header">
      <div className="de--header-title">
        <h2>Label Targets</h2>
      </div>
      <LabelActions exportTarget={exportTarget} />
    </div>
  );
};

TargetLabelMainHeader.propTypes = {
  exportTarget: func,
};

export default TargetLabelMainHeader;
